import { APIService } from "../apiService";
import { AuthenticationService } from "../authenticationService";
import {
  ISOString,
  ActiveAntsWarehouseCheckIn,
  PaginatedData,
  GetWarehouseCheckInsQueryParams,
  PatchWarehouseCheckInOpsNoteRequestBody,
  S3SignedUrl
} from "src/types";

export type PaginatedActiveAntsWarehouseCheckIns = PaginatedData<ActiveAntsWarehouseCheckIn>;

class ActiveAntsWarehouseCheckInAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/active-ants-warehouse-check-ins");
  }

  async getActiveAntsWarehouseCheckIns(
    queryParams: GetWarehouseCheckInsQueryParams
  ): Promise<PaginatedActiveAntsWarehouseCheckIns> {
    return await this.jwtRequest("GET", undefined, undefined, queryParams);
  }

  async getActiveAntsWarehouseCheckInById(
    warehouseCheckInId: string,
    timestamp: ISOString
  ): Promise<ActiveAntsWarehouseCheckIn> {
    const idPathParam = encodeURIComponent(warehouseCheckInId);
    const timestampPathParam = encodeURIComponent(timestamp);
    return await this.jwtRequest("GET", `/${idPathParam}/${timestampPathParam}`);
  }

  async patchActiveAntsWarehouseCheckInOpsNote(
    warehouseCheckInId: string,
    timestamp: ISOString,
    requestBody: PatchWarehouseCheckInOpsNoteRequestBody
  ): Promise<ActiveAntsWarehouseCheckIn> {
    const idPathParam = encodeURIComponent(warehouseCheckInId);
    const timestampPathParam = encodeURIComponent(timestamp);
    return await this.jwtRequest("PATCH", `/${idPathParam}/${timestampPathParam}/ops-note`, requestBody);
  }

  async postActiveAntsGoodsInExportUrl(exportFileId: string): Promise<S3SignedUrl> {
    const pathParam = encodeURIComponent(exportFileId);
    return await this.jwtRequest("POST", `/${pathParam}/goods-in-export-url`);
  }
}

export { ActiveAntsWarehouseCheckInAPIService };
